module.exports = __webpack_public_path__ + "static/media/081-bermuda.65c03f75.svg";